<template>
    <div class="row quick-stats">
        <div class="col-sm-3" v-for="entry in getEntries">
            <div class="stats__item">
                <div class="stats__chart bg-cyan">
                    <div class="flot-chart flot-chart--xs stats-chart-1">

                    </div>
                </div>

                <div class="stats__info">
                    <div>
                        <h2>{{ entry['unit_price'].displayValue }}</h2>
                        <small>{{ entry['productname'].displayValue }}</small>
                    </div>
                    <div class="row pl-5 pr-5 mt-5">
                        <div class="input-group">
                            <span class="pt-4 mr-2">Quantité:</span>
                            <i class="zmdi zmdi-minus pt-4"></i>
                            <input type="text" class="form-control">
                            <i class="zmdi zmdi-plus pt-4"></i>
                            <button class="btn btn-success btn--icon ml-4"><i class="zmdi zmdi-shopping-cart-plus"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import List from '@/components/List'

    export default {
        extends: List,
    }
</script>